export default __webpack_public_path__ + "static/media/closewise-login-bg.1ded7137.png";